import { Component, EventEmitter, Output, input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { LucideAngularModule } from 'lucide-angular';
import { FullscreenMenuComponent } from '../fullscreen-menu/fullscreen-menu.component';
import { NavigationItem } from '../header/header.component';

@Component({
    selector: 'pax-bottom-navigation',
    standalone: true,
    imports: [RouterLink, RouterLinkActive, LucideAngularModule, FullscreenMenuComponent],
    templateUrl: './bottom-navigation.component.html',
    styleUrls: ['./bottom-navigation.component.scss'],
})
export class BottomNavigationComponent {
    readonly navigationItems = input<NavigationItem[]>([]);
    readonly moreLabel = input<string>('More');
    readonly availableLanguages = input<string[]>([]);
    readonly currentLang = input('');
    @Output() languageChange = new EventEmitter<string>();
    isMenuOpen = false;

    get mainNavigationItems(): NavigationItem[] {
        return this.navigationItems().slice(0, 3);
    }

    get moreNavigationItems(): NavigationItem[] {
        return this.navigationItems().slice(3);
    }

    toggleMenu(): void {
        this.isMenuOpen = !this.isMenuOpen;
    }
}
